import type { z } from 'zod';

import { QUESTION_TYPE_LABELS, QuestionType } from './enums';
import type { LegacyExamQuestionSchema } from './schemas';

type LegacyExamQuestionField = keyof z.infer<typeof LegacyExamQuestionSchema>;

const listAttributes = [
  'id',
  'labelParts',
  'maxMark',
  'type',
  'mcqOpts',
  'analytics',
  'criteria',
  'guides',
] as const satisfies readonly LegacyExamQuestionField[];

const getAttributes = [
  ...listAttributes,
  'subject',
  'examCode',
  'examId',
  'creationDatetime',
  'editDatetime',
  'topicCodes',
  'active',
] as const satisfies readonly LegacyExamQuestionField[];

const updateAttributes = [
  'labelParts',
  'criteria',
  'guides',
  'editDatetime',
] as const satisfies readonly LegacyExamQuestionField[];

export const LegacyExamQuestionAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

export const QUESTION_TYPES: {
  key: QuestionType;
  value: QuestionType;
  label: string;
  analyticsKey:
    | 'calculationAnalytics'
    | 'proofAnalytics'
    | 'shortAnswerAnalytics'
    | 'extendedResponseAnalytics'
    | 'multipleChoiceAnalytics'
    | 'graphingAnalytics';
}[] = [
  {
    key: QuestionType.Calculation,
    value: QuestionType.Calculation,
    label: QUESTION_TYPE_LABELS[QuestionType.Calculation],
    analyticsKey: 'calculationAnalytics',
  },
  {
    key: QuestionType.Proof,
    value: QuestionType.Proof,
    label: QUESTION_TYPE_LABELS[QuestionType.Proof],
    analyticsKey: 'proofAnalytics',
  },
  {
    key: QuestionType.ShortAnswer,
    value: QuestionType.ShortAnswer,
    label: QUESTION_TYPE_LABELS[QuestionType.ShortAnswer],
    analyticsKey: 'shortAnswerAnalytics',
  },
  {
    key: QuestionType.ExtendedResponse,
    value: QuestionType.ExtendedResponse,
    label: QUESTION_TYPE_LABELS[QuestionType.ExtendedResponse],
    analyticsKey: 'extendedResponseAnalytics',
  },
  {
    key: QuestionType.MultipleChoice,
    value: QuestionType.MultipleChoice,
    label: QUESTION_TYPE_LABELS[QuestionType.MultipleChoice],
    analyticsKey: 'multipleChoiceAnalytics',
  },
  {
    key: QuestionType.Graphing,
    value: QuestionType.Graphing,
    label: QUESTION_TYPE_LABELS[QuestionType.Graphing],
    analyticsKey: 'graphingAnalytics',
  },
];
